import React from 'react';
import TimeAgo from 'react-timeago';

export default function TimeSince({ datetime }) {
  return (<TimeAgo date={datetime} minPeriod={60} />);
}
